
import Buildings2 from "../../../assets/filled/Buildings2.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Buildings2Icon({ className, dataTestid = "Buildings2Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Buildings2 data-testid={dataTestid} className={classes} {...rest} />
  );
}
